import { RecordType } from "../../../../../../common/types/RecordType";
import { CanFileRecordBeChangedToQcDoneArgs } from "../../../../common/utils/validateFileRecordStatus";
import { FileRecordListingItem } from "../../../types/FileRecordListingItem";

export const mapFileRecordListingToStatusValidator = (
    fileRecord: FileRecordListingItem
): CanFileRecordBeChangedToQcDoneArgs => {
    switch (fileRecord.recordType) {
        case RecordType.Video:
            return {
                versions: fileRecord.versions,
                status: fileRecord.status,
                recordType: fileRecord.recordType,
                metadata: { aspectRatio: fileRecord.aspectRatio, duration: fileRecord.duration },
                hasSubtitle: !!fileRecord.subtitle,
                soundtracks: fileRecord.soundtracks
            };
        case RecordType.Audio:
            return {
                versions: fileRecord.versions,
                status: fileRecord.status,
                recordType: fileRecord.recordType,
                soundtracks: fileRecord.soundtracks
            };
        case RecordType.Subtitle:
            return {
                versions: fileRecord.versions,
                status: fileRecord.status,
                recordType: fileRecord.recordType,
                hasSubtitle: !!fileRecord.subtitle
            };
        default:
            throw new Error("Unsupported file record type");
    }
};
